import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import styled from 'styled-components';
import { SkapaText, SkapaTokens } from '@inter-ikea-guida/skapa';
import { UpsellProductItem } from './UpsellProductItem';
const StyledTitle = styled(SkapaText) `
  margin-top: 0;
`;
const StyledGridContainer = styled.div `
  margin-top: ${SkapaTokens.space100};
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-column-gap: ${SkapaTokens.space100};
`;
export const GuidaUpsellContent = ({ addToBagButton, translations, settings, isMetricMeasurements, currentStepData }) => {
    const showHeader = currentStepData.title.length > 0;
    return (_jsxs(_Fragment, { children: [showHeader && (_jsx(StyledTitle, { tagName: 'h2', textStyle: 'Heading.M', children: currentStepData.title })), currentStepData.content, currentStepData.products.length && settings && (_jsx(StyledGridContainer, { "data-testid": 'upsell-product-grid', children: currentStepData.products.map((product, index) => (_jsx(UpsellProductItem, { index: index, translations: translations, AddToBagButton: addToBagButton, product: product, dexfSettings: settings, onAdd: () => { }, isMetric: isMetricMeasurements, theme: SkapaTheme }, product.productData.itemId))) }))] }));
};
//# sourceMappingURL=GuidaUpsellContent.js.map